import "./pdf-object.scss";

type PdfObjectProps = {
  url: string;
  fileName?: string;
};

export function PdfObject({ url, fileName = "document.pdf" }: PdfObjectProps) {
  return (
    <iframe
      src={url}
      title={fileName}
      className="pdf-object__iframe"
    />
  );
}
